<header class="sw-header sw-bg-surface border-bottom sw-border-subtle d-flex align-items-center justify-content-between flex-shrink-0 gap-1">
  <div class="d-flex align-items-center gap-2 gap-md-4">
    <button
      type="button"
      class="sw-mobile-menu-btn d-xl-none"
      title="Open navigation"
      (click)="showSideBar()"
      aria-label="Open navigation">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>
    <div class="d-flex align-items-center gap-3">
      <img src="assets/images/sightlogo.png" alt="Sight Watch" class="sw-brand-logo" />
    </div>

    @if (loggedInUserDetails() && showIncidentNotifications()) {
    <div #incidentNotifMenu class="sw-notif-menu" [class.is-open]="incidentNotifOpen()">
      <button
        type="button"
        class="sw-notif-trigger"
        [class.sw-notif-trigger--active]="incidentCount() > 0"
        [attr.aria-expanded]="incidentNotifOpen()"
        aria-haspopup="true"
        title="Incident notifications"
        (click)="toggleIncidentNotifications($event)">
        <svg class="sw-notif-bell" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        <span class="sw-notif-title d-none d-sm-inline">
          Incidents
          @if (incidentCount() > 0) {
          <span class="sw-notif-count">({{ incidentCount() }})</span>
          }
        </span>
      </button>
      <div class="sw-notif-dropdown" role="menu" (click)="$event.stopPropagation()">
        <div class="sw-notif-list">
          @if (incidentLoading()) {
            <div class="sw-notif-empty">Loading...</div>
          } @else if (incidentItems().length === 0) {
            <div class="sw-notif-empty">No incidents</div>
          } @else {
            @for (item of incidentItems(); track item.id) {
              <button type="button" class="sw-notif-item" role="menuitem" (click)="openIncidentAlert(item)">
                <div class="sw-notif-item-title">{{ item.title }}</div>
                @if (item.meta) {
                  <div class="sw-notif-item-meta">{{ item.meta }}</div>
                }
              </button>
            }
          }
        </div>
      </div>
    </div>
    }

  </div>

  @if (loggedInUserDetails()) {
  <div class="d-flex align-items-center gap-2 gap-md-4 sw-text-2xs sw-font-mono sw-tracking-wider sw-text-zinc-500">
    <!-- Inactive sites moved out of the header: they now have their own sidebar tab
         and page (/inactive-sites), which shows the same list with filters and paging. -->

    <div #userMenu class="sw-user-menu" [class.is-open]="userMenuOpen()">
      <button type="button" class="sw-user-trigger" [attr.aria-expanded]="userMenuOpen()" aria-haspopup="true"
        (click)="toggleUserMenu($event)">
        <span class="sw-user-avatar" aria-hidden="true">{{ userInitials() }}<app-chat-avatar-img [src]="userPhoto()" /></span>
        <span class="sw-user-meta">
          <span class="sw-user-name">{{ loggedInUserDetails().first_name }} {{ loggedInUserDetails().last_name }}</span>
          <span class="sw-user-email">{{ loggedInUserDetails().email }}</span>
        </span>
        <svg class="sw-user-chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </button>
      <div class="sw-user-dropdown" role="menu">
        <button type="button" class="sw-user-logout" role="menuitem" (click)="onLogout()">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Log out
        </button>
      </div>
    </div>
  </div>
  }
</header>
